/*
 * @Author: 刘枫 
 * @Date: 2021-04-28 14:11:40 
 * @Description: 缴费方式组件
 * @Last Modified by:   liufeng 
 * @Last Modified time: 2021-04-28 14:11:40 
 */

<template>
  <div class="pay-way">
    <div class="pay-way-title">{{article.ftitle}}</div>
    <div class="pay-way-info">
      <span class="laiyuan">{{article.fsource}}</span>
      <div class="info-content-time">
        发布日期：{{article.fcreatedate | ellipsis}}
      </div>
      <div class="info-content-watchers">
        <span class="iconfont iconchakan"></span>
        <span class="watchers-count">{{article.fhitsall}}</span>
      </div>
    </div>
    <div class="pay-way-content" @click="imageChange($event)" v-html="article.fcontent">
    </div>
    <div class="bottom-watchers-down">
      <span class="watchers-down" @click="down" v-show="article.ffileurl">
        <van-icon name="down" />点击下载
      </span>
    </div>
    <div v-show="xiazaiShow" @click="xiazaiShow = false" style="background: rgba(0,0,0,.5);
              width: 100%;
              position: fixed;
              top: 0;
              z-index: 1039;
              height: 100%;">
      <img style="padding: 10px;width: 95%;" :src="require('../../assets/images/xiazai.png')" />
    </div>
    <van-image-preview v-model="previewShow" fit="contain" :images="imgArr" :start-position="startPosition">
    </van-image-preview>
  </div>
</template>

<script>
// import wx from "weixin-js-sdk";
export default {
  name: 'PayWay',
  props: {
    article: Object,
    title: String
  },
  data() {
    return {
      newimglist: [],
      previewShow: false,
      imgArr: [],
      startPosition: 0,
      xiazaiShow: false
    }
  },
  components: {
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10);
      }
      return value;
    },
  },
  mounted() {
    window.response2({
      method: "onSingleDownload",
      cb: data => {
        this.$loading("下载中...");
        console.log(data)
        if (data.code == 0 && data.total > 0 && data.current > 0 && data.current == data.total) {
          this.$clear();
          console.log('onSingleDownload', data);
          this.$toast('下载成功')
        } else {
          this.$clear();
          this.$toast('下载失败')
        }
      }
    })
  },
  methods: {
    // 点击下载
    down() {
      console.log('下载地址' + this.article.ffileurl)
      if (!this.$comm.titleShow()) {
        console.log('app下载')
        // app的下载方式
        // 获取文件类型
        let index = this.article.ffileurl.lastIndexOf('.')
        this.$native.singleDownload({
          params: {
            "path": "",
            "name": this.article.ftitle + this.article.ffileurl.substring(index),
            "url": this.article.ffileurl,
            "unzip": false
          },
          cb: function (res) {
            console.log('singleDownload cb ', res)
          }
        })
      } else {
        // 微信端下载方式
        window.location.href = this.article.ffileurl
        // if(this.$comm.isIos()){
        //   console.log('ios下载')
        //   window.location.href = this.article.ffileurl
        // }else{
        //   console.log('安卓下载')
        //   this.xiazaiShow = true  
        // }
      }
    },
    // 点击预览
    imageChange(e) {
      var current = e.target.src
      if (current) {
        this.newimglist = this.article.fcontent.match(
          /<img[^>]*src=['"]([^'"]+)[^>]*>/gi
        )
        let srclist = []
        let index = 0
        for (var j = 0; j < this.newimglist.length; j++) {
          this.newimglist[j].replace(
            /<img[^>]*src=['"]([^'"]+)[^>]*>/gi,
            function (match, capture) {
              console.log('www')
              if (capture.substring(capture.indexOf('/uploadfiles')) === current.substring(current.indexOf('/uploadfiles'))) {
                index = j
              }
              srclist.push(capture);
            }
          );
        }
        this.startPosition = index
        this.newimglist = srclist
        console.log('集合' + srclist + '当前' + current + '当前位置' + this.startPosition)
        this.imgArr = this.newimglist
        this.previewShow = true
      } else {
        console.log('未点击图片')
      }

    }
  },
}
</script>

<style lang="less" scoped>
/deep/img {
  max-width: 100%;
  height: auto;
  width: 100%;
}
.pay-way {
  padding: 13px 16px;
  background: rgba(255, 255, 255, 1);
  .pay-way-title {
    font-size: 16px;
    font-weight: bold;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    text-align: center;
    padding: 10px 0 10px 0;
    line-height: 1.5em;
    position: relative;
    border-bottom: 1px solid #eeeeee;
  }
  .laiyuan {
    color: #7aa8ea;
    font-size: 15px;
    margin-right: 10px;
    width: 38%;
  }
  .pay-way-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .info-content-time {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8f8f8f;
    }
    .info-content-watchers {
      .iconfont {
        color: #8f8f8f;
        margin-left: 15px;
        font-size: 13px;
      }
      .watchers-count {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8f8f8f;
        margin-left: 5px;
      }
    }
  }
  .pay-way-content {
    padding: 10px;
    padding-bottom: 0;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    overflow: auto;
  }
}
.bottom-watchers-down {
  position: relative;
  padding: 10px;
  .watchers-down {
    color: #7aa8ea;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: right;
    margin-left: 10px;
    position: absolute;
    right: 0;
    bottom: 5px;
  }
}
</style>